/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_EmptyInputs */

const cs_share_empty = /** @type {(inputs: Share_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`V tomto sdílení nejsou žádné soubory.`)
};

const en_share_empty = /** @type {(inputs: Share_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No files in this share.`)
};

/**
* | output |
* | --- |
* | "No files in this share." |
*
* @param {Share_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const share_empty = /** @type {((inputs?: Share_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_share_empty(inputs)
	return cs_share_empty(inputs)
});